module.exports = __webpack_public_path__ + "img/skiing_cover.7e9f8c3d.png";